var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.083,
    height: 17.083,
    viewBox: "0 0 17.083 17.083",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon-analytics",
    d: "M3.828,18.113l4.379-3.66,4.877,1.182a1.233,1.233,0,0,0,.8-.073l4.227-1.977L17.6,12.48l-4.219,1.97L8.5,13.268a1.222,1.222,0,0,0-1.062.234L3.47,16.82v-3.29L8.207,9.572l4.877,1.182a1.233,1.233,0,0,0,.8-.073L18.113,8.7,17.6,7.6,13.375,9.57,8.5,8.387a1.223,1.223,0,0,0-1.062.234L3.47,11.939V8.65L8.207,4.691l4.877,1.182a1.233,1.233,0,0,0,.8-.073l4.227-1.973L17.6,2.722,13.375,4.689,8.5,3.507a1.222,1.222,0,0,0-1.062.234L3.47,7.059V2.25H2.25V18.113a1.22,1.22,0,0,0,1.22,1.22H19.333v-1.22Z",
    transform: "translate(-2.25 -2.25)",
    fill: "#45338c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAnalytics);
export default __webpack_public_path__ + "static/media/icon-analytics.8e34fea0c9cfeba933f5c948c91d564d.svg";
export { ForwardRef as ReactComponent };